import { FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material';
import { Input } from 'reactstrap';

const SelectInput = (props: any) => {
    const value = props.formValue !== undefined ? props.formValue : '';
    const isMultiple = props.isMultiple || false;

    return (
        <>
            <FormControl
                variant={props.className ? undefined : "standard"}
                sx={{ minWidth: '95%', maxWidth: '95%' }}
                required={props.required}
            >
                <InputLabel
                    sx={{
                        fontSize: '13px',
                        '& .MuiFormLabel-asterisk': {
                            color: 'red'
                        }
                    }}
                >
                    {!props?.className && props.label}
                </InputLabel>
                <Select
                    autoComplete='off'
                    aria-autocomplete='none'
                    multiple={isMultiple}                    
                    onChange={arg => props.changeFun(props.valueName, arg.target.value)}
                    value={value}
                    {...props.register}
                    sx={{ fontSize: '13px' }}
                    className={props.className}
                    name={props?.valueName}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                maxHeight: '260px !important',
                                maxWidth: '180px !important',
                            },
                        },
                    }}
                    disabled={props.disabled}
                    renderValue={(selected: any) => isMultiple ? selected.join(', ') : selected}
                >
                    {props.data?.filter((each: any) => each.status !== false).map((each: any) => (
                        <MenuItem
                            value={each.label}
                            key={each.value}
                            style={{ fontSize: '13px', textWrap: 'wrap', }}
                            disabled={each.isDisabled}
                        >
                            {isMultiple && 
                                <Input 
                                    type="checkbox"  
                                    checked={value.includes(each.label)} 
                                    className='custom-checkbox' 
                                    onChange={()=>{}}
                                />}
                            <p style={{margin:'5px 0 0 7px'}}>{each.label}</p>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {(props?.errors?.[props.valueName]?.type === "required") && 
                <p role="alert" className='error-msg'>{props?.label} is required</p>
            }
        </>
    );
}

export default SelectInput;